/*global locationWithDefaultsData, onlyDates, analyticEventTracker, storage, Mustache, inputDirectionChange, abTest470, multiErrorMsg  */

var autocomplete = {
    pickVal: '',
    dropVal: '',
    mode: 'basic',
    originalplacePick: $('#pickPlaceID').val(),
    originalplaceDrop: $('#dropPlaceID').val(),
    locationSubmitEventInProgress: false,
    recentSearchSelected: 0,
    init: function(mode) {
        autocomplete.mode = mode;
        autocomplete.action();
        autocomplete.engine($('.typeahead.pick' + (mode === 'modal' ? '.on-modal' : '')), 'pick');
        autocomplete.engine($('.typeahead.drop' + (mode === 'modal' ? '.on-modal' : '')), 'drop');
        if (mode === 'basic') {
            autocomplete.actionsForBasic();
        }
        if (_d.page === 'static-index') {
            autocomplete.parseRecentSearch();
            autocomplete.recentSearchAction();
        }
        autocomplete.checkPlaceHanlerTextDirection();

        autocomplete.isABTest470 = typeof abTest470 !== 'undefined' && abTest470 === 1;
    },
    actionsForBasic: function() {
        $('#location-submit').on('click', function(e) {
            e.preventDefault();

            let isFirstSearch = autocomplete.originalplacePick === '' && autocomplete.originalplaceDrop === '';

            if (!autocomplete.locationSubmitEventInProgress && !isFirstSearch) {
                let isLocationTheSame = autocomplete.originalplacePick === $('#pickPlaceID').val() && autocomplete.originalplaceDrop === $('#dropPlaceID').val();

                let postData = {
                    eventName: 'Search_ChangeLocation',
                    attributes: {
                        'attributeLocationChangedFromOriginal': !isLocationTheSame
                    }
                };

                analyticEventTracker.trackEvent(postData);
                autocomplete.locationSubmitEventInProgress = true;

                setTimeout(function() {
                    autocomplete.locationSubmitEventInProgress = false;
                }, 1000);
            }

            var that = $(this);
            that.addClass('loading');
            autocomplete.submitSearchForm(that);
        });

        $('#pick-up-location, #drop-off-location').focus(function() {
            autocomplete.mode = 'basic';
        });

        inputDirectionChange.onChangeAction('#pick-up-location, #drop-off-location');
    },
    action: function() {
        $('body').on('keyup', '.tt-input', function() {
            var that = $(this),
                location = that.val(),
                parentHandler = that.parents('.autocomplete-box');

            if (that.hasClass('pick')) {
                autocomplete.pickVal = location;
            } else {
                autocomplete.dropVal = location;
            }

            if (location.length > 0) {
                parentHandler.find('.clear-auto-complete').removeClass('hide');
                parentHandler.find('.typeahead').removeClass('error');
            } else {
                parentHandler.find('.clear-auto-complete').addClass('hide');
            }
        });

        if (_d.s.device === 301) {
            $('body').on('focus', '.tt-input', function() {
                var inputHeight = $(this).offset().top - 60;
                $('html, body').animate({ scrollTop: inputHeight }, 600);
            });
        }

        $('.clear-auto-complete').on('click', function(e) {
            e.preventDefault();
            var $this = $(this),
                parentHandler = $this.parents('.autocomplete-box');

            parentHandler.find('.typeahead').typeahead('val', '');
            if (autocomplete.isABTest470) {
                parentHandler.find('label').hide();
            }
            parentHandler.find('.place-handler').text('').addClass('hide');
            parentHandler.find('.tt-input').blur();

            $this.addClass('hide');
            autocomplete.updateLocationID('0', '0', '0', (parentHandler.hasClass('pick') ? 'pick' : 'drop'));
        });

        $('.place-handler').on('click', function() {
            var that = $(this),
                parentHandler = that.parents('.autocomplete-box'),
                field = parentHandler.find('.tt-input');

            if (field.val().length < 1) {
                parentHandler.find('.clear-auto-complete').addClass('hide');
            }
            field.focus();
            that.addClass('hide');
            if (autocomplete.isABTest470) {
                that.siblings('label').hide();
            }
        });
    },
    engine: function(handler, type) {
        var parentHandler = handler.parents('.autocomplete-box'),
            locationsDB = new Bloodhound({
                datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                remote: {
                    url: _d.url.autocomplete + '/%QUERY',
                    prepare: function(query, settings) {
                        settings.url = _d.url.autocomplete + '/' + query;
                        settings.headers = {
                            'Page': _d.page
                        };

                        return settings;
                    },
                    wildcard: '%QUERY',
                    cache: false
                }
            });

        function locationWithDefaults(q, sync, async) {
            if (typeof locationWithDefaultsData !== 'undefined') {
                if (q === '') {
                    sync(locationWithDefaultsData);
                } else {
                    locationsDB.search(q, sync, async);
                }
            } else {
                locationsDB.search(q, sync, async);
            }
        }

        handler.typeahead({
                highlight: false,
                minLength: _d.isSymbolicLang ? 1 : (typeof locationWithDefaultsData !== 'undefined' ? 0 : 2),
                hint: false
            },
            {
                name: 'locations',
                source: locationWithDefaults,
                display: 'place',
                limit: 30,
                templates: {
                    empty: [
                        '<div class="location-404">' + $('.not-found-message').text() + '</div>'
                    ],
                    pending: function() {
                        $('.recent-searches').hide();
                        return '<div class="searching">' + _d.t.searching + '</div>';
                    },
                    suggestion: function(e) {
                        $('.tt-dataset').animate({
                            scrollTop: 0
                        }, 100);
                        var ltrText = !inputDirectionChange.isRtlText(e.placeHlt + e.cityHlt + e.countryHlt);
                        var ltrTextClass = ltrText ? ' ltr' : '';
                        return ('<div class="location-item ' + e.location + ltrTextClass + '">' + e.placeHlt + ' <div class="spot">' + e.cityHlt + ', ' + e.countryHlt + '</div></div>');
                    }
                }
            }).bind('typeahead:select', function(ev, response) {

            var locationText = (response.placeID !== response.cityID ? response.place + ', ' : '') + response.city + ', ' + response.country;

            if (window._d.isRTL && (inputDirectionChange.isArabic(locationText) || inputDirectionChange.isHebrew(locationText))) {
                parentHandler.closest('.ltr').removeClass('ltr');
            }
            autocomplete.updateLocationID(response.countryID, response.cityID, response.placeID, type);
            if (type === 'pick' && $('#is-drop-off').prop('checked')) {
                autocomplete.updateLocationID(response.countryID, response.cityID, response.placeID, 'drop');
            }
            handler.typeahead('val', (type === 'pick' ? autocomplete.pickVal : autocomplete.dropVal));
            if (autocomplete.isABTest470 && !parentHandler.find('label').is(':visible')) {
                parentHandler.find('label').show();
            }
            parentHandler.find('.place-handler').text(locationText).removeClass('hide');
            parentHandler.find('.clear-auto-complete').removeClass('hide');
            handler.blur();
            autocomplete.checkPlaceHanlerTextDirection();
        });
    },
    updateLocationID: function(country, city, place, type) {
        var countryPickElement = $('#pickCountryID'),
            cityPickElement = $('#pickCityID'),
            placePickElement = $('#pickPlaceID'),
            countryDropElement = $('#dropCountryID'),
            cityDropElement = $('#dropCityID'),
            placeDropElement = $('#dropPlaceID');

        if (autocomplete.mode === 'modal') {
            countryPickElement = $('#pick-country-modal');
            cityPickElement = $('#pick-city-modal');
            placePickElement = $('#pick-place-modal');
            countryDropElement = $('#drop-country-modal');
            cityDropElement = $('#drop-city-modal');
            placeDropElement = $('#drop-place-modal');
        } else if (autocomplete.mode === 'modify-modal') {
            countryPickElement = $('.modal #pick-country-modal');
            cityPickElement = $('.modal #pick-city-modal');
            placePickElement = $('.modal #pick-place-modal');
            countryDropElement = $('.modal #drop-country-modal');
            cityDropElement = $('.modal #drop-city-modal');
            placeDropElement = $('.modal #drop-place-modal');
        }

        if (country) {
            type === 'pick' ? countryPickElement.val(country) : countryDropElement.val(country);
        }
        if (city) {
            type === 'pick' ? cityPickElement.val(city) : cityDropElement.val(city);
        }
        if (place) {
            type === 'pick' ? placePickElement.val(place) : placeDropElement.val(place);
        }
        autocomplete.checkPlaceHanlerTextDirection();
    },
    submitSearchForm: function(that) {
        var error = false,
            errorMsg = [],
            dateFrom = $('#pick-date').val() + ' ' + $('#pick-time').val(),
            timeFrom = $('#pick-time').val(),
            dateTill = $('#drop-date').val() + ' ' + $('#drop-time').val(),
            timeTill = $('#drop-time').val(),
            placePick = $('#pickPlaceID').val(),
            placeDrop = $('#dropPlaceID').val();
        var driverAge = $('#driver-age-input').val();

        if (driverAge === '30-65' || driverAge === '65-30') {
            driverAge = '35';
        } else if (driverAge === '80+') {
            driverAge = '80';
        }

        const regex = /(?:\?|&)abtest\[(\d+)\]=(\d)/;
        const match = regex.exec(window.location.search);
        let abtest = null;

        if (match) {
            abtest = {
                [match[1]]: match[2]
            };
        }

        var post = {
            is_drop_off: ($('#is-drop-off').is(':checked') ? 0 : 1),
            pick_up_country_id: $('#pickCountryID').val(),
            pick_up_city_id: $('#pickCityID').val(),
            pick_up_location_id: placePick,
            drop_off_country_id: $('#dropCountryID').val(),
            drop_off_city_id: $('#dropCityID').val(),
            drop_off_location_id: placeDrop,
            pickup_id: placePick,
            dropoff_id: placeDrop,
            pickup_from: dateFrom,
            pickup_to: dateTill,
            pick_time: timeFrom,
            drop_time: timeTill,
            partner_id: $('#partnerId').val(),
            exclude_locations: $('#excludeLocations').val(),
            luxOnly: 0,
            driver_age: driverAge,
            residence_country: $('#residence-input').val(),
            abtest,
            token: ''
        };

        if (placePick === 0 || $('.place-handler.pick').html().length === 0) {
            $('.typeahead.pick').addClass('error');
            that.removeClass('loading');
            errorMsg.push(_d.t.selectPickUp);
            error = true;
        }

        if (post.is_drop_off === 1) {
            if (placeDrop === 0 || $('.place-handler.drop').html().length === 0) {
                $('.typeahead.drop').addClass('error');
                errorMsg.push(_d.t.selectDropOff);
                error = true;
            }
        }

        if (timeFrom === '0') {
            $('.time-select.pick').addClass('err');
            errorMsg.push(_d.t.selectPickTime);
            error = true;
        }

        if (timeTill === '0') {
            $('.time-select.drop').addClass('err');
            errorMsg.push(_d.t.selectDropTime);
            error = true;
        }

        if (dateFrom === dateTill && timeFrom !== '0' && timeTill !== '0') {
            $('.time-select').addClass('err');
            errorMsg.push(_d.t.wrongTimes);
            error = true;
        }

        if (error) {
            var errorHandler = $('.inline-error');
            errorHandler.html('');

            if (errorMsg.length > 1 && autocomplete.isABTest470) {
                errorHandler.append(
                    `<p class="text-16 text-medium text-gray-900-new multi-error-message">
                        ${multiErrorMsg}
                    </p>`
                );
            }

            var ul = $('<ul class="error-list"></ul>');

            if (errorMsg.length > 1 && autocomplete.isABTest470) {
                ul.addClass('multiple-errors');
            }

            errorHandler.append(ul);

            errorMsg.forEach(msg => ul.append(`<li>${msg}</li>`));

            that.removeClass('loading');
            autocomplete.secondFormError();
            errorHandler.slideDown();
            return false;
        }

        const recentSearches = storage.get('recentSearches') || [];
        if (autocomplete.isRecentSearch(recentSearches, post, autocomplete.recentSearchSelected)) {
            post.recent_search = 1;
        }

        autocomplete.postSearchForm(post, recentSearches, that);
    },
    postSearchForm: function(post, recentSearches, that) {
        $.post(_d.url.search.createSearch, post, function(response) {
            if (response.success) {
                autocomplete.saveRecentSearches(recentSearches, post);
                document.location.href = response.data.url;
            } else {
                var errorHandler = $('.inline-error');

                that.removeClass('loading');
                errorHandler.html('').append('<ul class="error-list"></ul>');

                $.each(response.errors.message, function(index) {
                    if (typeof response.errors.message[index] !== 'undefined') {
                        $('.error-list').append('<li>' + response.errors.message[index] + '</li>');
                    }
                });

                autocomplete.secondFormError();

                $.each(response.errors.fields, function(index, value) {
                    if (autocomplete.isABTest470) {
                        $('#' + value).closest('.sb-group').addClass('error');
                    } else {
                        $('#' + value).addClass('err');
                    }
                });

                errorHandler.slideDown();
            }
        }, 'json');
    },
    secondFormError: function() {
        if (typeof onlyDates !== 'undefined' && onlyDates) {
            $('html, body').animate({
                scrollTop: 0
            }, 400, function() {
                $('#ssf-submit').removeClass('loading');
            });
        }
    },
    saveRecentSearches: function(recentSearches, searchData) {
        const exists = autocomplete.isRecentSearch(recentSearches, searchData);

        if (!exists) {
            recentSearches.push(searchData);
            storage.save('recentSearches', recentSearches);
        }
    },
    isRecentSearch: function(recentSearches, searchData, isSelected = 1) {
        searchData.recent_search = isSelected;
        return recentSearches.some(obj => {
            obj.recent_search = 1;
            return JSON.stringify(obj) === JSON.stringify(searchData);
        });
    },
    parseRecentSearch: function() {
        const limit = 3;
        let recentSearches = storage.get('recentSearches');

        if (recentSearches === null) {
            return;
        }

        if (recentSearches.length > limit) {
            recentSearches.splice(0, recentSearches.length - limit);
        }

        for (let i = recentSearches.length - 1; i >= 0; i--) {
            // Remove searches that are in the past
            if (new Date(_d.s.now) >= new Date(recentSearches[i].pickup_from)) {
                recentSearches.splice(i, 1);
            }
        }

        if (recentSearches.length > 0) {
            storage.save('recentSearches', recentSearches);

            $.ajax({
                url: _d.url.search.recent,
                type: 'POST',
                dataType: 'json',
                data: JSON.stringify(recentSearches),
                contentType: 'application/json; charset=utf-8',
                success: function(response) {
                    $('.recent-searches').html(Mustache.render($('#tpl-recent-searches').text(), response));
                },
                error: function() {
                    $('.recent-searches').remove();
                }
            });
        } else {
            storage.delete('recentSearches');
        }
    },
    showRecentSearch: function(element) {
        if (storage.get('recentSearches') !== null) {
            $('.recent-searches').hide();
            $(`[data-id=${element}]`).show();
        }
    },
    recentSearchAction: function() {
        $('#pick-up-location, #drop-off-location').on('focus keyup', function() {
            if ($(this).val().length < 2) {
                autocomplete.showRecentSearch($(this).attr('id'));
            }
        });

        $('.recent-searches').on('click', '.recent-searches__location', function() {
            if (storage.get('recentSearches') !== null) {
                const that = $(this);
                const pickHandler = $('.autocomplete-box.pick');
                const dropHandler = $('.autocomplete-box.drop');
                const recentSearches = storage.get('recentSearches');
                const response = recentSearches[that.data('search-key')];
                const isDropOff = $('#is-drop-off');

                autocomplete.recentSearchSelected = 1;

                $('#driver-age-input').val(response.driver_age);
                $('#residence-input').val(response.residence_country);
                $('#partnerId').val(response.partner_id);
                $('#excludeLocations').val(response.exclude_locations);

                var yearRange = window._d.isRTL ? '65-30' : '30-65';
                $('.sb-driver-age-text').text(response.driver_age === '35' ? yearRange : response.driver_age);
                $('.sb-residence-text').text($('#residence-country option[value=' + response.residence_country + ']').text());

                $('#pick-date-ui').datepicker('setDate', new Date(that.data('pick-date')));
                $('#drop-date-ui').datepicker('setDate', new Date(that.data('drop-date')));

                $('#pick-time').val(response.pick_time).trigger('chosen:updated');
                $('#drop-time').val(response.drop_time).trigger('chosen:updated');

                autocomplete.updateLocationID(response.pick_up_country_id, response.pick_up_city_id, response.pick_up_location_id, 'pick');
                autocomplete.updateLocationID(response.drop_off_country_id, response.drop_off_city_id, response.drop_off_location_id, 'drop');
                pickHandler.find('.place-handler').text(that.data('pick')).removeClass('hide');
                pickHandler.find('.clear-auto-complete').removeClass('hide');
                if (response.is_drop_off === 1) {
                    if (isDropOff.prop('checked')) {
                        isDropOff.trigger('click');
                    }

                    dropHandler.find('.place-handler').text(that.data('drop')).removeClass('hide');
                    dropHandler.find('.clear-auto-complete').removeClass('hide');
                } else if (!isDropOff.prop('checked')) {
                    isDropOff.trigger('click');
                }

                $('.recent-searches').hide();
            }
        }).on('click', '.clear-recent-searches', function(e) {
            e.preventDefault();
            storage.delete('recentSearches');
            $('.recent-searches').remove();
        });
    },
    checkPlaceHanlerTextDirection: function() {
        if (window._d.isRTL) {
            $('.place-handler').each( function() {
                var self = $(this);
                var text = self.text();

                if (!inputDirectionChange.isRtlText(text)) {
                    self.addClass('ltr');
                    self.siblings('.clear-auto-complete').addClass('ltr');
                } else {
                    self.removeClass('ltr');
                    self.siblings('.clear-auto-complete').removeClass('ltr');
                }
            });
        }
    }
};
